import { render, staticRenderFns } from "./postFooter.vue?vue&type=template&id=346a4318"
import script from "./postFooter.vue?vue&type=script&lang=js"
export * from "./postFooter.vue?vue&type=script&lang=js"
import style0 from "./postFooter.vue?vue&type=style&index=0&id=346a4318&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports